import Repository from "./repository";
const getPrices = "/payment/prices";

export default {
  getPaymentPrices() {
    return Repository.get(`${getPrices}`);
  },
};
